import MarketToday from '../../../../common/src/sections/home/MarketToday';

// Species ID 2 = Cherries (hardcoded for importers app)
const CHERRY_SPECIES_ID = 2;

const MarketTodayPage = () => {
  return (
    <MarketToday
      forceSpeciesId={CHERRY_SPECIES_ID}
      hideExporterPrice
      hideMaxExporters
    />
  );
};

export default MarketTodayPage;
